var filter = function() {
  return function(input) {
    return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
  };
};

filter.$inject = [];

tiz.filter('capitalize', filter);

var uppercaseFilter = function() {
  return function(input) {
    return input.toUpperCase();
  };
};

tiz.filter('uppercase', uppercaseFilter);
